export type UploadState =
    "PendingUpload"
    | "Uploading"
    | "PendingResponse"
    | "Done";